import {Helper, SelectControl} from '../../../../app/shared/classes';
import {ComponentTypesEnum} from '../../../../app/shared/enums/common';

export const CompanyProofOfAddressDocumentTypeSelector = 'proofOfAddressDocumentType';

export const CompanyProofOfAddressControl = (): SelectControl => {
    return new SelectControl({
        name: CompanyProofOfAddressDocumentTypeSelector,
        value: null,
        placeholder: 'Document type',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: Helper.enumsHelper().getProofOfAddressDocumentTypes().getTypeKeys().map((key: string) => {
            return {
                label: Helper.enumsHelper().getProofOfAddressDocumentTypes().getTypeValue(key),
                value: key
            };
        })
    });
};
